import { render, staticRenderFns } from "./RegionProvinceManage.vue?vue&type=template&id=0531602c&scoped=true"
import script from "./RegionProvinceManage.vue?vue&type=script&lang=js"
export * from "./RegionProvinceManage.vue?vue&type=script&lang=js"
import style0 from "./RegionProvinceManage.vue?vue&type=style&index=0&id=0531602c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0531602c",
  null
  
)

export default component.exports